/**
 * @flow
 * @relayHash 01fd5e91f0b028746f9d9c62479167f3
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CategoryEditInput = {
  id: string,
  name: string,
  section: string,
  hidden?: ?boolean,
  clientMutationId?: ?string,
};
export type CategoryEditMutationVariables = {|
  input: CategoryEditInput
|};
export type CategoryEditMutationResponse = {|
  +CategoryEdit: ?{|
    +Category: ?{|
      +id: string
    |},
    +error: ?string,
  |}
|};
export type CategoryEditMutation = {|
  variables: CategoryEditMutationVariables,
  response: CategoryEditMutationResponse,
|};
*/


/*
mutation CategoryEditMutation(
  $input: CategoryEditInput!
) {
  CategoryEdit(input: $input) {
    Category {
      id
    }
    error
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CategoryEditInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "CategoryEdit",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "CategoryEditInput!"
      }
    ],
    "concreteType": "CategoryEditPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "Category",
        "storageKey": null,
        "args": null,
        "concreteType": "Category",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "error",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "CategoryEditMutation",
  "id": null,
  "text": "mutation CategoryEditMutation(\n  $input: CategoryEditInput!\n) {\n  CategoryEdit(input: $input) {\n    Category {\n      id\n    }\n    error\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "CategoryEditMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "CategoryEditMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b165c1aa3875fce58e8eab480b907a94';
module.exports = node;



// WEBPACK FOOTER //
// src/mutations/__generated__/CategoryEditMutation.graphql.js